import React from 'react';
import { Tooltip } from 'antd';
import { isNil } from 'ramda';

const RichTooltip = ({ title, children, className = '', innerStyle = {} }) => {
  if (isNil(title)) return children;

  return (
    <Tooltip
      color="#1A1A2E"
      overlayClassName={`flexi-rich-tooltip ${className}`}
      overlayInnerStyle={innerStyle}
      placement="top"
      title={title}
    >
      {children}
    </Tooltip>
  );
};

export default RichTooltip;
